// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, isSupported } from "firebase/messaging";
import secureLocalStorage from "react-secure-storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBd7T8812xrj6xn2k9ZbTd8wa_RclavmaE",
  authDomain: "itc-tradenext-df6c2.firebaseapp.com",
  projectId: "itc-tradenext-df6c2",
  storageBucket: "itc-tradenext-df6c2.firebasestorage.app",
  messagingSenderId: "429740590624",
  appId: "1:429740590624:web:1a6cb88ae2f6544b15de45",
  measurementId: "G-QWH4FGP4T8",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = (await isSupported()) && getMessaging(firebaseApp);
export const isMessaging = async () => {
  if (await isSupported()) {
    return getMessaging(firebaseApp);
  }
  return null;
};

export const getPermission = async () => {
  await Notification.requestPermission()
    .then(async (permission) => {
      try {
        if (permission === "granted") {
          // safe to call getToken()
          await getToken(messaging, {
            vapidKey:
              "BB4mS6ZoLGpHDZmtVF9XFBXr3hyUQRI8q7uqf87LEAaqduGuptuG9Ecm2GfyyhBHISEZAJoyQX5Hz_N4TA1FSbo",
          })
            .then((deviceToken) => {
              if (deviceToken) {
                console.log("FCM Token:", deviceToken);
                secureLocalStorage.setItem("deviceToken", deviceToken);
              } else {
                console.warn(
                  "No registration token available. Request permission to generate one."
                );
              }
            })
            .catch((err) => {
              console.error("An error occurred while retrieving token. ", err);
            });
        }
      } catch (error) {
        console.error(error);
      }
    })
    .catch((e) => console.error(e));
};
